import { Outlet } from "react-router-dom";

/** Chrome-free layout for iframed report pages (no header, nav, or page padding). */
export function BareLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Outlet />
    </div>
  );
}
